// `fill-secondary-disabled` instead of `fill-secondary-active` because
// the latter ships a hover state (designed for buttons / active tiles)
// — and on hover the shimmer's colour matched the form background
// dead-on, so the pulse blended out the moment the user moved the cursor
// over the gallery. The `-disabled` variant is the same semantic family
// (secondary surface) but explicitly non-interactive, no hover override.
export const ImageGallerySkeletonTile = () => (
  <div
    data-testid='image-gallery__skeleton-tile'
    className='w-[60px] h-[60px] rounded-md animate-pulse fill-secondary-disabled shrink-0'
  />
);
